export const RoutePaths = {
    home: '/',
    login: '/login',
    direction: '/direction',
    resetPassword: '/reset-password',
    register: '/register',
    myAccount: '/my-account',
    KYCUpload:'/kyc-upload',
    myCompany: '/my-company',
    myServices: '/my-services',
    myServicesItem: '/my-services/:id',
    services:'/services',
    support:'/support',
    orderPayment:'/orderPayment',
} as const
